export function applyRefBinding(element, nodeId, props, refBindings) {
    const maybeRef = props.ref;
    const nextRef = typeof maybeRef === 'function'
        ? maybeRef
        : null;
    const prevRef = refBindings.get(nodeId);
    if (prevRef && prevRef !== nextRef) {
        prevRef(null);
    }
    if (!nextRef) {
        refBindings.delete(nodeId);
        return;
    }
    if (prevRef !== nextRef) {
        nextRef(element);
    }
    refBindings.set(nodeId, nextRef);
}
export function cleanupRefBinding(nodeId, refBindings) {
    const ref = refBindings.get(nodeId);
    if (!ref) {
        return;
    }
    ref(null);
    refBindings.delete(nodeId);
}
export function cleanupAllRefBindings(refBindings) {
    for (const ref of refBindings.values()) {
        ref(null);
    }
    refBindings.clear();
}
//# sourceMappingURL=ref-bindings.js.map